export default __webpack_public_path__ + "static/media/bnr1.438a35be.jpg";